"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _pipelineBuilder = _interopRequireDefault(require("./pipelineBuilder"));

var _assignmentBuilder = _interopRequireDefault(require("./assignmentBuilder"));

var _types = _interopRequireDefault(require("../metadata/types"));

var _cyclicIncrementor = _interopRequireDefault(require("../../util/cyclicIncrementor"));

var _lodash = require("lodash");

var pidGenerator = (0, _cyclicIncrementor.default)(1);

function builder(commandRegistry, environment) {
  var pid = pidGenerator.next();
  var context = {
    commandRegistry: commandRegistry,
    environment: environment,
    pid: pid
  };
  var pipelines = [];
  var assignments = [];
  return {
    addPipeline: function addPipeline() {
      var builder = (0, _pipelineBuilder.default)(context);
      pipelines.push(builder);
      return builder;
    },
    addVariable: function addVariable(key, scope) {
      var builder = (0, _assignmentBuilder.default)(key, scope, context);
      assignments.push(builder);
      return builder;
    },
    getMetadata: function getMetadata() {
      return _defineProperty({}, _types.default.PROGRAM, {
        assignments: assignments.map(function (assignment) {
          return assignment.getMetadata();
        }),
        pipelines: pipelines.map(function (pipeline) {
          return pipeline.getMetadata();
        })
      });
    },
    build: function build() {
      var buildOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var process = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, opts) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return Promise.all(assignments.map(function (assignment) {
                    return assignment.build(buildOpts);
                  }).map( /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
                      var _ref5, key, scope, value, execVal;

                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _ref5 = _slicedToArray(_ref3, 3), key = _ref5[0], scope = _ref5[1], value = _ref5[2];

                              if (!(0, _lodash.isFunction)(value)) {
                                _context.next = 7;
                                break;
                              }

                              _context.next = 4;
                              return value();

                            case 4:
                              _context.t0 = _context.sent;
                              _context.next = 8;
                              break;

                            case 7:
                              _context.t0 = value;

                            case 8:
                              execVal = _context.t0;
                              environment.set(key, execVal, {
                                scope: scope === 'local' && buildOpts.scope
                              });

                            case 10:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3) {
                      return _ref4.apply(this, arguments);
                    };
                  }()));

                case 2:
                  _context3.next = 4;
                  return Promise.all(pipelines.map( /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pipeline) {
                      var pipelineOutput;
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              pipelineOutput = pipeline.build(buildOpts);
                              _context2.next = 3;
                              return pipelineOutput(args, opts);

                            case 3:
                              return _context2.abrupt("return", _context2.sent);

                            case 4:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    return function (_x4) {
                      return _ref6.apply(this, arguments);
                    };
                  }()));

                case 4:
                  return _context3.abrupt("return", _context3.sent);

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function process(_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }();

      process.pid = pid;
      return process;
    }
  };
}

var _default = builder;
exports.default = _default;